import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom';
import ArrowLeft from '../../Assets/Arrow left.svg';
import AgedInventoryItemList from './Components/AgedInventoryList/AgedInventoryList';
import TabButton from '../../Components/TabButton/TabButton';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAgedInventory } from '../../Features/reportAnalysisSlice';

function AgedInventory() {
    const dispatch = useDispatch();

    const agedInventory = useSelector((state) => state.reportAnalysis.agedInventory.agedInventory);

    const location = useLocation();

    const [activeRange, setActiveRange] = useState('first');
    const [activeList, setActiveList] = useState([]);

    const updateActiveRange = (selection) => {
        setActiveRange(selection);
    }

    useEffect(() => {
        if (agedInventory.length > 0) {
            const now = new Date();

            const rangeMap = {
                first: [0, 3],
                second: [4, 6],
                third: [7, 9],
                fourth: [10, 12]
            };

            const [min, max] = rangeMap[activeRange] || [0, 3]; // fallback to 'first'

            const filtered = agedInventory.filter(item => {
                const updatedAt = new Date(item.updatedAt);
                const diffInMonths = (now.getFullYear() - updatedAt.getFullYear()) * 12 +
                                    (now.getMonth() - updatedAt.getMonth());

                return diffInMonths >= min && diffInMonths <= max;
            });

            setActiveList(filtered);
        }
    }, [agedInventory, activeRange]);

    useEffect(() => {
        dispatch(fetchAgedInventory());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="w-full overflow-y-scroll pb-16">
            <div className="flex items-center justify-between gap-6 relative m-[20px_19px_24px_20px]">
                <div className="w-fit flex items-center">
                    <Link to={`${location.pathname.split('/').slice(0, -1).join('/')}`} className="img p-[10px] flex items-center justify-center">
                        <img className='size-6 text-[#666666]' src={ArrowLeft} alt="" />
                    </Link>

                    <h1 className="p-[6px] text-[#121212] font-bold leading-8 text-[24px]">Aged Inventory</h1>
                </div>
            </div>

            <div className="flex border-b-[2px] border-[#F5F5F5] m-[0px_19px_0px_20px]">
                <TabButton 
                    id='first' 
                    optionName='0 - 3 months' 
                    selected={activeRange} 
                    handleSelect={updateActiveRange} 
                />
                <TabButton 
                    id='second' 
                    optionName='3 - 6 months' 
                    selected={activeRange} 
                    handleSelect={updateActiveRange} 
                />
                <TabButton 
                    id='third' 
                    optionName='6 - 9 months' 
                    selected={activeRange} 
                    handleSelect={updateActiveRange} 
                />
                <TabButton 
                    id='fourth' 
                    optionName='9 - 12 months' 
                    selected={activeRange} 
                    handleSelect={updateActiveRange} 
                />
            </div>

            <AgedInventoryItemList 
                activeList={activeList} 
            />
        </div>
    );
}

export default AgedInventory;
